import React, { useState, useEffect } from "react";
import { 
    Card, Row, Col, Button, Badge, Table, Spinner, Alert,
    ListGroup, Modal, Form, ProgressBar
} from "react-bootstrap";
import { useParams, useNavigate, Link } from "react-router-dom";
import { formatCurrency, formatDate } from "../utils/formatters";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";

// Styles corrigés
const styles = `
  /* Layout principal */
  .detail-commande {
    padding: 20px;
    max-width: 1400px;
    margin: 0 auto;
  }

  /* En-tête */
  .page-header {
    background: linear-gradient(135deg, #4361ee, #3a56d4);
    border-radius: 12px;
    padding: 20px 25px;
    margin-bottom: 25px;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
  }

  .page-header h1 {
    font-size: 1.8rem;
    font-weight: 600;
    margin: 0 0 5px 0;
  }

  .page-header p {
    margin: 0;
    opacity: 0.9;
    font-size: 0.95rem;
  }

  /* Grille de cartes */
  .stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-bottom: 25px;
  }

  /* Cartes */
  .stat-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    overflow: hidden;
    border: none;
  }

  .stat-card-header {
    background: #f8f9fa;
    padding: 12px 15px;
    border-bottom: 1px solid #e9ecef;
  }

  .stat-card-header h6 {
    margin: 0;
    font-size: 0.9rem;
    font-weight: 600;
    color: #495057;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .stat-card-header i {
    color: #4361ee;
    font-size: 1rem;
  }

  .stat-card-body {
    padding: 15px;
  }

  /* Badge de statut */
  .badge-statut {
    display: inline-block;
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
  }

  /* Cartes d'information */
  .info-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 25px;
  }

  .info-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    border: none;
  }

  .info-card-header {
    background: #f8f9fa;
    padding: 12px 15px;
    border-bottom: 1px solid #e9ecef;
  }

  .info-card-header h6 {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
    color: #495057;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .info-card-body {
    padding: 0;
  }

  .info-row {
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    border-bottom: 1px solid #f1f3f5;
    font-size: 0.95rem;
  }

  .info-row:last-child {
    border-bottom: none;
  }

  .info-label {
    color: #6c757d;
    font-weight: 500;
  }

  .info-value {
    font-weight: 600;
    color: #212529;
    text-align: right;
  }

  /* Tableau */
  .table-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    border: none;
    margin-bottom: 25px;
  }

  .table-header {
    background: #f8f9fa;
    padding: 12px 15px;
    border-bottom: 1px solid #e9ecef;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .table-header h6 {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
    color: #495057;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .table-container {
    padding: 15px;
    overflow-x: auto;
  }

  .table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.9rem;
  }

  .table th {
    background: #f8f9fa;
    padding: 12px 10px;
    text-align: left;
    font-weight: 600;
    color: #495057;
    border-bottom: 2px solid #dee2e6;
    white-space: nowrap;
  }

  .table td {
    padding: 10px;
    border-bottom: 1px solid #e9ecef;
    vertical-align: middle;
  }

  .table tbody tr:hover {
    background: #f8f9fa;
  }

  .text-right {
    text-align: right;
  }

  .text-center {
    text-align: center;
  }

  /* Badge de référence */
  .ref-badge {
    background: #e9ecef;
    color: #495057;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.8rem;
    font-family: monospace;
    font-weight: 500;
  }

  /* Progress bar */
  .progress-custom {
    width: 60px;
    height: 6px;
    background: #e9ecef;
    border-radius: 3px;
    overflow: hidden;
    display: inline-block;
    margin-right: 8px;
  }

  .progress-custom-bar {
    height: 100%;
    background: #4361ee;
    border-radius: 3px;
  }

  .progress-custom-bar.success {
    background: #10b981;
  }

  .progress-custom-bar.warning {
    background: #f59e0b;
  }

  /* Totaux */
  .totaux-section {
    background: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
    margin: 0 15px 15px 15px;
  }

  .total-row {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
    font-size: 0.95rem;
  }

  .grand-total {
    font-weight: 700;
    font-size: 1.1rem;
    border-top: 2px solid #dee2e6;
    margin-top: 8px;
    padding-top: 8px;
  }

  /* Boutons */
  .btn-group {
    display: flex;
    gap: 10px;
  }

  .btn-icon {
    width: 36px;
    height: 36px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
  }

  .btn-sm-custom {
    padding: 6px 16px;
    font-size: 0.85rem;
    border-radius: 6px;
    font-weight: 500;
  }

  /* Responsive */
  @media (max-width: 992px) {
    .stats-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 768px) {
    .detail-commande {
      padding: 15px;
    }
    
    .stats-grid {
      grid-template-columns: 1fr;
    }
    
    .info-section {
      grid-template-columns: 1fr;
    }
    
    .page-header {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .page-header h1 {
      font-size: 1.5rem;
    }
  }
`;

export default function DetailCommande() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [commande, setCommande] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showReceptionModal, setShowReceptionModal] = useState(false);
    const [lignesRecues, setLignesRecues] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [isCancelling, setIsCancelling] = useState(false);

    useEffect(() => {
        fetchCommande();
    }, [id]);

    const fetchCommande = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const response = await fetch(
                `https://sawd.julesferry-ga.com/api/commandes_fournisseurs.php?id=${id}`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            
            if (!response.ok) throw new Error("Erreur chargement");
            
            const result = await response.json();
            setCommande(result.data);
            
            if (result.data?.lignes) {
                setLignesRecues(result.data.lignes.map(l => ({
                    id_ligne_commande: l.id_ligne_commande,
                    quantite_commandee: l.quantite_commandee,
                    quantite_recue: l.quantite_recue || 0,
                    a_recevoir: 0
                })));
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleConfirmCancel = async () => {
        setIsCancelling(true);
        
        try {
            const token = localStorage.getItem("token");
            const response = await fetch('https://sawd.julesferry-ga.com/api/commandes_fournisseurs.php', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    action: 'annuler',
                    id: commande.id_commande_fournisseur
                })
            });
            
            const result = await response.json();
            
            if (result.success) {
                setShowCancelModal(false);
                fetchCommande();
            } else {
                alert(result.message || "Erreur lors de l'annulation");
                setShowCancelModal(false);
            }
        } catch (err) {
            alert("Erreur de connexion au serveur");
            setShowCancelModal(false);
        } finally {
            setIsCancelling(false);
        }
    };

    const handleReception = async () => {
        setIsUpdating(true);
        
        try {
            const token = localStorage.getItem("token");
            const lignes = lignesRecues
                .filter(l => l.a_recevoir > 0)
                .map(l => ({
                    id_ligne_commande: l.id_ligne_commande,
                    quantite_recue: l.a_recevoir
                }));
            
            const response = await fetch('https://sawd.julesferry-ga.com/api/commandes_fournisseurs.php', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    action: 'marquer_recue',
                    id: commande.id_commande_fournisseur,
                    lignes_recues: lignes
                })
            });
            
            const result = await response.json();
            
            if (result.success) {
                setShowReceptionModal(false);
                fetchCommande();
            }
        } catch (err) {
            alert("Erreur lors de la réception");
        } finally {
            setIsUpdating(false);
        }
    };

    const getStatutStyle = (statut) => {
        const styles = {
            brouillon: { background: '#6c757d', label: 'Brouillon' },
            envoyee: { background: '#17a2b8', label: 'Envoyée' },
            recue_partielle: { background: '#ffc107', label: 'Partiellement reçue' },
            recue_complete: { background: '#28a745', label: 'Reçue' },
            annulee: { background: '#dc3545', label: 'Annulée' }
        };
        return styles[statut] || styles.brouillon;
    };

    if (loading) {
        return (
            <>
                <Header />
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                    <Spinner animation="border" variant="primary" />
                    <span className="ms-3">Chargement...</span>
                </div>
            </>
        );
    }

    if (error || !commande) {
        return (
            <>
                <Header />
                <div className="p-4">
                    <Alert variant="danger" className="text-center">
                        <h5>{error || "Commande non trouvée"}</h5>
                        <Button variant="outline-danger" size="sm" className="mt-2" onClick={() => navigate('/achats/commandes')}>
                            Retour
                        </Button>
                    </Alert>
                </div>
            </>
        );
    }

    const statutStyle = getStatutStyle(commande.statut);

    return (
        <>
            <style>{styles}</style>
            <Header />
<div className="main main-app p-3 p-lg-4">
                <div className="container-fluid">

            <div className="detail-commande">
                {/* En-tête */}
                <div className="page-header">
                    <div>
                        <h1>{commande.numero_commande}</h1>
                        <p>
                            <i className="ri-store-line me-2"></i>
                            {commande.fournisseur_nom} • {formatDate(commande.date_commande)}
                        </p>
                    </div>
                    <div className="btn-group">
                        <button 
                            className="btn btn-light btn-icon"
                            onClick={() => navigate('/achats/commandes')}
                            title="Retour"
                        >
                            <i className="ri-arrow-left-line"></i>
                        </button>
                        
                        {commande.statut === 'brouillon' && (
                            <Link 
                                to={`/achats/commandesModifier/${commande.id_commande_fournisseur}`}
                                className="btn btn-light btn-icon"
                                title="Modifier"
                            >
                                <i className="ri-pencil-line"></i>
                            </Link>
                        )}
                        
                        {['envoyee', 'recue_partielle'].includes(commande.statut) && (
                            <button 
                                className="btn btn-success btn-sm-custom"
                                onClick={() => setShowReceptionModal(true)}
                            >
                                <i className="ri-check-double-line me-1"></i>
                                Réceptionner
                            </button>
                        )}
                        
                        {['brouillon', 'envoyee'].includes(commande.statut) && (
                            <button 
                                className="btn btn-danger btn-sm-custom"
                                onClick={() => setShowCancelModal(true)}
                            >
                                <i className="ri-close-circle-line me-1"></i>
                                Annuler
                            </button>
                        )}
                    </div>
                </div>

                {/* Cartes de statistiques */}
                <div className="stats-grid">
                    {/* Statut */}
                    <div className="stat-card">
                        <div className="stat-card-header">
                            <h6><i className="ri-information-line"></i> Statut</h6>
                        </div>
                        <div className="stat-card-body text-center">
                            <span className="badge-statut" style={{ background: statutStyle.background }}>
                                {statutStyle.label}
                            </span>
                            <div className="mt-2 small text-muted">
                                {formatDate(commande.date_modification)}
                            </div>
                        </div>
                    </div>

                    {/* Montant */}
                    <div className="stat-card">
                        <div className="stat-card-header">
                            <h6><i className="ri-money-euro-circle-line"></i> Montant</h6>
                        </div>
                        <div className="stat-card-body text-center">
                            <div className="h4 text-primary fw-bold mb-0">{formatCurrency(commande.montant_ttc || 0)}</div>
                            <small className="text-muted">TTC</small>
                        </div>
                    </div>

                    {/* Livraison */}
                    <div className="stat-card">
                        <div className="stat-card-header">
                            <h6><i className="ri-calendar-line"></i> Livraison</h6>
                        </div>
                        <div className="stat-card-body text-center">
                            <div className="mb-1">{commande.date_livraison_prevue ? formatDate(commande.date_livraison_prevue) : 'Non spécifiée'}</div>
                            {commande.date_livraison_prevue && (
                                <Badge bg={new Date(commande.date_livraison_prevue) < new Date() ? 'danger' : 'success'} pill>
                                    {new Date(commande.date_livraison_prevue) < new Date() ? 'En retard' : 'À temps'}
                                </Badge>
                            )}
                        </div>
                    </div>

                    {/* Progression */}
                    <div className="stat-card">
                        <div className="stat-card-header">
                            <h6><i className="ri-stack-line"></i> Progression</h6>
                        </div>
                        <div className="stat-card-body">
                            <div className="d-flex justify-content-between align-items-center mb-2 small">
                                <span>Reçu</span>
                                <span className="fw-bold">
                                    {commande.lignes?.reduce((acc, l) => acc + (l.quantite_recue || 0), 0)} / {commande.lignes?.reduce((acc, l) => acc + l.quantite_commandee, 0)}
                                </span>
                            </div>
                            <div className="progress-custom" style={{ width: '100%' }}>
                                <div 
                                    className={`progress-custom-bar ${commande.lignes?.reduce((acc, l) => acc + (l.quantite_recue || 0), 0) === commande.lignes?.reduce((acc, l) => acc + l.quantite_commandee, 0) ? 'success' : ''}`}
                                    style={{ width: `${(commande.lignes?.reduce((acc, l) => acc + (l.quantite_recue || 0), 0) / commande.lignes?.reduce((acc, l) => acc + l.quantite_commandee, 0)) * 100}%` }}
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Informations détaillées */}
                <div className="info-section">
                    {/* Fournisseur */}
                    <div className="info-card">
                        <div className="info-card-header">
                            <h6><i className="ri-store-line"></i> Fournisseur</h6>
                        </div>
                        <div className="info-card-body">
                            <div className="info-row">
                                <span className="info-label">Raison sociale</span>
                                <span className="info-value">{commande.fournisseur_nom}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Code</span>
                                <span className="info-value">{commande.code_fournisseur}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Téléphone</span>
                                <span className="info-value">{commande.fournisseur_telephone || '-'}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Email</span>
                                <span className="info-value">{commande.fournisseur_email || '-'}</span>
                            </div>
                        </div>
                    </div>

                    {/* Détails */}
                    <div className="info-card">
                        <div className="info-card-header">
                            <h6><i className="ri-file-list-line"></i> Détails</h6>
                        </div>
                        <div className="info-card-body">
                            <div className="info-row">
                                <span className="info-label">Date commande</span>
                                <span className="info-value">{formatDate(commande.date_commande)}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Créée par</span>
                                <span className="info-value">{commande.prenom_utilisateur} {commande.nom_utilisateur}</span>
                            </div>
                            {commande.conditions_reglement && (
                                <div className="info-row">
                                    <span className="info-label">Conditions</span>
                                    <span className="info-value">{commande.conditions_reglement}</span>
                                </div>
                            )}
                            <div className="info-row">
                                <span className="info-label">Articles</span>
                                <span className="info-value">{commande.lignes?.length || 0}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tableau des produits */}
                <div className="table-card">
                    <div className="table-header">
                        <h6><i className="ri-stack-line"></i> Lignes de commande</h6>
                        <Badge bg="primary" pill>{commande.lignes?.length || 0} article(s)</Badge>
                    </div>
                    <div className="table-container">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Réf.</th>
                                    <th>Désignation</th>
                                    <th className="text-right">Qté</th>
                                    <th className="text-right">Prix unit.</th>
                                    <th className="text-right">Remise</th>
                                    <th className="text-right">Total HT</th>
                                    <th className="text-center">Réception</th>
                                </tr>
                            </thead>
                            <tbody>
                                {commande.lignes?.map(ligne => (
                                    <tr key={ligne.id_ligne_commande}>
                                        <td>
                                            <span className="ref-badge">{ligne.reference}</span>
                                        </td>
                                        <td>{ligne.designation}</td>
                                        <td className="text-right">{ligne.quantite_commandee}</td>
                                        <td className="text-right">{formatCurrency(ligne.prix_unitaire_ht)}</td>
                                        <td className="text-right">{ligne.remise ? `${ligne.remise}%` : '-'}</td>
                                        <td className="text-right fw-bold text-primary">{formatCurrency(ligne.montant_ligne_ht || 0)}</td>
                                        <td className="text-center">
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                <div className="progress-custom">
                                                    <div 
                                                        className={`progress-custom-bar ${ligne.quantite_recue === ligne.quantite_commandee ? 'success' : 'warning'}`}
                                                        style={{ width: `${(ligne.quantite_recue / ligne.quantite_commandee) * 100}%` }}
                                                    ></div>
                                                </div>
                                                <Badge bg={ligne.quantite_recue === ligne.quantite_commandee ? 'success' : 'warning'} pill>
                                                    {ligne.quantite_recue || 0}/{ligne.quantite_commandee}
                                                </Badge>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Totaux */}
                    <div className="totaux-section">
                        <div className="total-row">
                            <span>Total HT</span>
                            <span className="fw-bold">{formatCurrency(commande.montant_ht || 0)}</span>
                        </div>
                        <div className="total-row">
                            <span>TVA (18%)</span>
                            <span className="fw-bold text-warning">{formatCurrency(commande.montant_tva || 0)}</span>
                        </div>
                        <div className="total-row">
                            <span>CSS (1%)</span>
                            <span className="fw-bold text-info">{formatCurrency(commande.montant_css || 0)}</span>
                        </div>
                        <div className="total-row grand-total">
                            <span>Total TTC</span>
                            <span className="text-primary">{formatCurrency(commande.montant_ttc || 0)}</span>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>

            {/* Modal de réception */}
            <Modal show={showReceptionModal} onHide={() => setShowReceptionModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="ri-inbox-archive-line me-2 text-success"></i>
                        Réceptionner la commande
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <table className="table table-sm">
                        <thead>
                            <tr>
                                <th>Produit</th>
                                <th className="text-center">Commandé</th>
                                <th className="text-center">Reçu</th>
                                <th className="text-center">Restant</th>
                                <th className="text-center">À recevoir</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lignesRecues.map((ligne, index) => {
                                const restant = ligne.quantite_commandee - ligne.quantite_recue;
                                return (
                                    <tr key={ligne.id_ligne_commande}>
                                        <td>{commande.lignes[index].designation}</td>
                                        <td className="text-center">{ligne.quantite_commandee}</td>
                                        <td className="text-center">
                                            <Badge bg="success" pill>{ligne.quantite_recue}</Badge>
                                        </td>
                                        <td className="text-center">
                                            <Badge bg="warning" pill>{restant}</Badge>
                                        </td>
                                        <td className="text-center">
                                            <Form.Control
                                                type="number"
                                                min="0"
                                                max={restant}
                                                value={ligne.a_recevoir}
                                                onChange={(e) => {
                                                    const newLignes = [...lignesRecues];
                                                    newLignes[index].a_recevoir = parseInt(e.target.value) || 0;
                                                    setLignesRecues(newLignes);
                                                }}
                                                size="sm"
                                                style={{ width: '80px', margin: '0 auto' }}
                                                className="text-center"
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant="secondary" onClick={() => setShowReceptionModal(false)}>
                        Annuler
                    </Button>
                    <Button 
                        size="sm"
                        variant="success" 
                        onClick={handleReception}
                        disabled={isUpdating || lignesRecues.every(l => l.a_recevoir === 0)}
                    >
                        {isUpdating ? <Spinner size="sm" /> : 'Confirmer la réception'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal d'annulation */}
            <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="text-warning">
                        <i className="ri-alert-line me-2"></i>
                        Annuler la commande
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-3">
                        Êtes-vous sûr de vouloir annuler la commande <strong>{commande.numero_commande}</strong> ?
                    </p>
                    <Alert variant="warning" className="mb-0 py-2">
                        <i className="ri-information-line me-2"></i>
                        Cette action est irréversible.
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant="secondary" onClick={() => setShowCancelModal(false)}>
                        Non, conserver
                    </Button>
                    <Button 
                        size="sm"
                        variant="warning" 
                        onClick={handleConfirmCancel}
                        disabled={isCancelling}
                    >
                        {isCancelling ? <Spinner size="sm" /> : 'Oui, annuler'}
                    </Button>
                </Modal.Footer>
            </Modal>

            </div>
            </div>
        </>
    );
}